module.exports = __webpack_public_path__ + "static/img/top.9f45a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top.png
// module id = rOIf
// module chunks = 0